import React from "react";
import { AuthorizationStatus } from "./types";
import { Authorizations } from "..";

class AuthorizationsPage extends React.Component {
  state = {
    role: "",
    location: {
      hash: null,
    },
    filters: {
      text: "",
      status: null,
      fromDate: (() => {
        const date = new Date();
        date.setMonth(date.getMonth() - 6);
        return date;
      })(),
      toDate: new Date(),
    },
    modalAuth: {
      open: false,
    },
    authorizations: [],
    loading: false,
    hasMore: true,
    page: 0,
    pageSize: 20,
    skip: 0,
    isAdvancedFilterActive: false, 
  };
  
  changeAdvancedFilter = (props) => {
    const { dispatch, authorizationsSuccess, fetchGetAuthorizations } = this.props;
    const { pageSize } = this.state;
    
    this.setState(
      {
        filters: { ...this.state.filters, ...props },
        isAdvancedFilterActive: true,
        authorizations: [],
        skip: 0, 
        hasMore: true,
        isAdvancedFilterLoading: true, 
      },
      () => {
        fetchGetAuthorizations({
          all: true,
          length: 50,
          filter: {
            Length: pageSize,
            Offset: 0,
            FromDate: props.fromDate,
            ToDate: props.toDate,
            Text: props.text,
            Status: typeof props.status === "string" ? props.status : "",
          }
        }).then((r) => {
          dispatch(authorizationsSuccess(r.authorizations));
          this.setState({
            authorizations: r.authorizations,
            skip: pageSize, 
            hasMore: r.authorizations.length === pageSize,
            isAdvancedFilterLoading: false,  
          });
        });
      }
    );
  };

  loadAuthorizations = () => {
    const { dispatch, authorizationsSuccess, fetchGetAuthorizations } = this.props;
    const { pageSize, skip, filters, isAdvancedFilterActive, isAdvancedFilterLoading } = this.state;

    
    if (isAdvancedFilterActive && isAdvancedFilterLoading) return;

    this.setState({ loading: true }, () => {
      const filterOptions = isAdvancedFilterActive
        ? {
            Length: pageSize,
            Offset: skip,
            FromDate: filters.fromDate,
            ToDate: filters.toDate,
            Text: filters.text,
            Status: typeof filters.status === "string" ? filters.status : "",
          }
        : {
            Length: pageSize,
            Offset: skip,
          };

      fetchGetAuthorizations({
        all: true,
        length: 50,
        filter: filterOptions,
      }).then((r) => {
        dispatch(authorizationsSuccess(r.authorizations));

        this.setState((prevState) => ({
          authorizations:
            skip === 0 ? [...r.authorizations] : [...prevState.authorizations, ...r.authorizations],
          loading: false,
          hasMore: r.authorizations.length === pageSize,
          skip: prevState.skip + pageSize,
        }));
      });
    });
  };


  componentDidMount() {
    const session = this.props.getSession();
    this.setState({ role: session.UserRoleName });
    if (session.Advisor && session.Advisor.manager) {
      this.setState({ manager: true });
    }else
    {
      this.setState({manager: false });
    }
  }

  componentDidUpdate(prevProps) {
    const locationState = this.props.location.state;
    const { location } = this.state;
    const { authorizations } = this.props;

    if (locationState && locationState.id) {
      if (authorizations == null) return;

      if (location.hash !== locationState.hash) {
        this.setState({
          location: { ...location, hash: locationState.hash },
        });
        this.toggleModal("modalAuth", {
          authorization: authorizations.find((a) => a.id === locationState.id),
        });
      }
    }
  }

  toggleModal = (name, props) => {
    this.setState({ [name]: { open: !this.state[name].open, ...props } });
  };

  changeFilter = (props) => {
    this.setState({
      filters: { ...this.state.filters, ...props },
      authorizations: [],
      skip: 0,
      page: 0,
      hasMore: true,
    });
  };
  
  handleReadAuthorization = (authorization) => {
    const { username, fetchSetAsReadAuthorization } = this.props;
    if (!authorization.wasReadBy.includes(username) && authorization.status !== AuthorizationStatus.Waiting) {
      this.props.actions.authorizationsRead(authorization.id, username);
      fetchSetAsReadAuthorization({ id: authorization.id });
    }
  };

  render() {
    const { filters, modalAuth, role, authorizations, loading, hasMore } = this.state;
    const { username, AuthorizationWrapper, getUser } = this.props;
    const filteredAuthorizations = filterAuthorizations(authorizations, filters, getUser());

    return (
      <div>
        <Authorizations.Toolbar
          changeFilter={this.changeFilter}
          filtersParent={filters}
          changeAdvancedFilter={this.changeAdvancedFilter}
          filters={filters}
          counters={{
            total: filteredAuthorizations ? filteredAuthorizations.length : 0,
            filtered: authorizations ? authorizations.length - filteredAuthorizations.length : 0,
          }}
          handleDownload={() => this.props.handleDownload(filteredAuthorizations)}
        />

        <Authorizations.Grid
          authorizations={filteredAuthorizations}
          username={username}
          actions={{
            toggleModal: this.toggleModal,
            setRead: this.handleReadAuthorization,
          }}
          loading={loading}
          loadMore={this.loadAuthorizations}
          hasMore={hasMore}
        />

        <AuthorizationWrapper
          {...modalAuth}
          role={role}
          manager={this.state.manager}
          username={this.props.username}
          toggle={(e) => this.toggleModal("modalAuth", e)}
        />
      </div>
    );
  }
}

function filterAuthorizations(authorizations, filters, username) {
  if (authorizations == null || authorizations.length == 0) return [];

  const filtered = authorizations.filter((a) => {
    if (filters.status) {
      const status = a.processedBy !== "" ? (a.authorized ? "Authorized" : "Rejected") : "Waiting";
      if (filters.status !== status) {
        return false;
      }
    }

    if (filters.text != null && filters.text !== "") {
      const parts = [a.title, a.process, a.AccountName, a.description, a.requestedBy].map((p) =>
        p ? p.trim().toLowerCase() : ""
      );
      return filters.text.split(" ").every((p) => parts.some((s) => s.includes(p)));
    }

    return true;
  });

  // Sort by status
  filtered.sort((a1, a2) => {
    const compare_wasRead = a1.wasReadBy.includes(username) - a2.wasReadBy.includes(username);
    const compare_waiting =
      (a2.requestedBy !== username && a2.processedBy === "") -
      (a1.requestedBy !== username && a1.processedBy === "");

    const compare_dateTime = new Date(a1.dateTime) - new Date(a2.dateTime);
    const compare_status =
      [AuthorizationStatus.Authorized, AuthorizationStatus.Rejected].includes(a1.status) -
      [AuthorizationStatus.Authorized, AuthorizationStatus.Rejected].includes(a2.status);

    return compare_wasRead || compare_waiting || compare_status || compare_dateTime;
  });

  return filtered;
}

export default AuthorizationsPage;
